import React from "react";
import { useToast } from "@finitless/shared/hooks";
import { convertFileToBase64 } from "@finitless/shared/lib";
import { ImageUpload } from "../../";

const PhotosStep = ({ logoFile, onLogoUpload, onLogoRemove }) => {
  const toast = useToast();

  const handleLogoFileChange = async (file) => {
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast.error("Please select a valid image file");
        return;
      }

      if (file.size > 512 * 1024) {
        toast.error("Image size must be less than 512KB");
        return;
      }

      try {
        const base64String = await convertFileToBase64(file);
        onLogoUpload({ file, base64: base64String });
      } catch (error) {
        console.error("Error converting logo to base64:", error);
        toast.error("Error processing image");
      }
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Logo Upload */}
      <div>
        <label className="text-foreground mb-2 block text-sm font-medium">
          Business Logo
        </label>
        <p className="text-muted-foreground mb-3 text-xs">
          Accepted formats: PNG, JPG, JPEG, WEBP (Max 512KB)
        </p>
        <div className="border-border hover:border-border rounded-lg border-2 border-dashed p-4 text-center transition-colors sm:p-6">
          <div className="flex flex-col items-center space-y-3">
            <ImageUpload
              image={logoFile}
              onChange={handleLogoFileChange}
              onRemove={onLogoRemove}
              size="md"
              showRemoveButton={true}
              alt="Logo preview"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotosStep;
